import React, { useContext } from 'react';
import FormImg from '../FormFiles/FormFiles';

import { acceptedExtensions, acceptedExtensionsDocuments } from '../../../services/hooks/documents/useUpload';
import Context from '../../../store/context';
import Button from '../../Buttons/Button/Button';
//import { ReactComponent as ViewDocument } from '../../../assets/icons/ViewDocument.svg';
//import { ReactComponent as XThinBlue } from '../../../assets/icons/XThinBlue.svg';
import DropFiles from '../DropFiles/DropFiles';

import classes from './UploadFiles.module.scss';
import ProgressBar from '../../ProgressBar/ProgressBar';

const maximunFiles = 25;

const UploadFiles = ({ setData, files, type }) => {
  const {
    modal: { showModal },
    toast: { showError }
  } = useContext(Context);

  const changeOtherFiles = async files => {
    if (type === 'documents') {
      const lessThanMaximum = files.length <= maximunFiles;
      if (!lessThanMaximum) {
        showError(`El número máximo de archivos es ${maximunFiles}`);
        return;
      }

      const allExtensionsCorrect = files.reduce((prev, { type }) => prev && acceptedExtensions.includes(type.split('/')[1]), true);
      if (!allExtensionsCorrect) {
        showError('La extensión de 1 o más archivos es incorrecta');
        return;
      }
      setData(currentFiles =>
        currentFiles.concat(
          files.map(dropFile => {
            const [name] = dropFile.name.split('.').slice(0);
            const [extension] = dropFile.name.split('.').slice(-1);
            return {
              name,
              extension,
              dropFile
            };
          })
        )
      );
    } else {
      if (
        files.every(file => {
          const [extension] = file.name.split('.').slice(-1);
          return acceptedExtensionsDocuments.includes(extension);
        })
      ) {
        const filesStructures = files.map(file => {
          const [extension] = file.name.split('.').slice(-1);
          const [name] = file.name.split('.').slice(0);
          return { dropFile: file, name: name, extension: extension, description: '' };
        });
        showModal(<FormImg files={filesStructures} onChange={setData} />);
      } else {
        showError('Formato no soportado. Intenta PDF o DOCX');
      }
    }
  };

  const deleteFile = idx => {
    setData(
      files.filter((value, index) => index !== idx),
      'delete'
    );
  };

  return (
    <>
      <DropFiles onDroppedFiles={files => changeOtherFiles(files)}>
        <div className={classes['drops-files']}>
          <Button custom='secondary'>Subir archivo</Button>
          <span className={`${classes.text} semibold-14`}>O arrastra el archivo</span>
        </div>
      </DropFiles>
      <div className={classes['list-files']}>
        <span className={`${classes.list} semibold-16`}>Documentos subidos</span>
        {files.length === 0 && <span className='semibold-14'>No se ha subido nada</span>}
        {files.length !== 0 &&
          files.map(({ name, extension, loaded, total }, idx) => (
            <div className={classes.card}>
              <div key={idx} className={classes.file}>
                {/* <ViewDocument className={classes.icon} /> */}
                <span className={`${classes.text} semibold-16`}>
                  {name}.{extension}
                </span>
                {/* <XThinBlue className={`pointer ${classes.delete}`} onClick={() => deleteFile(idx)} /> */}
              </div>
              <ProgressBar value={loaded} total={total} />
            </div>
          ))}
      </div>
    </>
  );
};

export default UploadFiles;
